module.exports = __webpack_public_path__ + "img/service-partner.ff8749fe.png";